import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74c357bc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c357bc')) {
      api.createRecord('74c357bc', component.options)
    } else {
      api.reload('74c357bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=74c357bc", function () {
      api.rerender('74c357bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/ExchangeRate/index.vue"
export default component.exports